<template>
  <v-container grid-list-xs>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="datesList"
          hide-actions
          class="elevation-1"
          loading="true"
          v-bind:pagination.sync="pagination"
        >
           <template v-slot:items="props">
            <td v-if="props.item.current">Actual</td>
            <td v-else>{{ props.item.priceChangeDate | formatDateTime }}</td>
            <td>
              <v-icon
                small
                @click="downloadHistory(props.item)"
              >save_alt</v-icon>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import { getPriceChangeDates } from '../services/priceHistory';
import qs from 'qs';
import moment from 'moment';
import download from 'js-file-download';
import FileSaver from 'file-saver';

export default {
  data() {
    return {
      pagination: {sortBy: 'column1', descending: true, rowsPerPage: -1},
      headers: [
        {
          text: 'Fecha',
          align: 'left',
          sortable: true,
          value: 'priceChangeDate',
        },
        {
          text: 'Descargar',
          width: '20%',
          sortable: false,
        },
      ],
      datesList: [],
    };
  },
  methods: {
    downloadHistory(item) {
      let url = `/priceHistory/historic.xls?date=${item.priceChangeDate}`;
      if (item.current) {
        url = `/priceHistory/historic.xls`;
      }
      this.axios.get(url, {responseType: 'blob'})
        .then((result) => {
          const blob =
            new Blob([ result.data ], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          FileSaver.saveAs(blob, `Precios${moment(new Date(item.priceChangeDate)).format('YYYY_MM_DD')}.xlsx`);
        })
        .catch((error) => {
          this.$emit('error', error.message);
        });
    },
  },
  async mounted() {
    try {
      const datesResults = await getPriceChangeDates();
      this.datesList = datesResults.data;
      this.datesList.unshift({ priceChangeDate: new Date(), current: true });
    } catch (error) {
      this.$emit('error', error.message);
    }
  },
};
</script>
